if (!customElements.get('scrolling-announcement-bar')) {
  customElements.define(
    'scrolling-announcement-bar',
    class ScrollingAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.scrolling-announcement__track');
        this.group = this.querySelector('.scrolling-announcement__group');
        if (!this.track || !this.group) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.speed = Number(this.dataset.speed) || 40;

        // Fires on viewport resize and when custom icon images load and widen the group.
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.group);

        if (window.Shopify && Shopify.designMode) {
          this.onBlockSelect = (event) => {
            if (this.contains(event.target)) this.classList.add('is-editing');
          };
          this.onBlockDeselect = (event) => {
            if (this.contains(event.target)) this.classList.remove('is-editing');
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        if (this.onBlockSelect) {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
      }

      update() {
        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        // Enough copies to cover the viewport, plus one so the loop never shows a gap.
        const copiesNeeded = Math.ceil(this.clientWidth / groupWidth) + 1;
        const clones = this.track.querySelectorAll('[data-clone]');

        if (clones.length !== copiesNeeded - 1) {
          clones.forEach((clone) => clone.remove());
          for (let i = 1; i < copiesNeeded; i++) {
            this.track.appendChild(this.createClone());
          }
        }

        this.style.setProperty('--sab-distance', `${groupWidth}px`);
        this.style.setProperty('--sab-duration', `${groupWidth / this.speed}s`);
        this.classList.add('is-scrolling');
      }

      createClone() {
        const clone = this.group.cloneNode(true);
        clone.dataset.clone = '';
        clone.inert = true;
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((block) => {
          block.removeAttribute('data-shopify-editor-block');
        });
        return clone;
      }
    }
  );
}
